/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Integrations_Kindle_DescriptionInputs */

const en_settings_integrations_kindle_description = /** @type {(inputs: Settings_Integrations_Kindle_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen to your Kindle books with Listening voices.`)
};

const es_settings_integrations_kindle_description = /** @type {(inputs: Settings_Integrations_Kindle_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha tus libros Kindle con las voces de Listening.`)
};

/**
* | output |
* | --- |
* | "Listen to your Kindle books with Listening voices." |
*
* @param {Settings_Integrations_Kindle_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_integrations_kindle_description = /** @type {((inputs?: Settings_Integrations_Kindle_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Integrations_Kindle_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_integrations_kindle_description(inputs)
	return en_settings_integrations_kindle_description(inputs)
});